import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { PassKeyRenameComponent } from "./pass-key-rename.component";


class RenamePasskeyFormSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    passKeyRenameComponentRef: ComponentRef<PassKeyRenameComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside rename passkey form constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Rename Passkey Form session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Rename Passkey Form session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Rename Passkey Form session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<PassKeyRenameComponent> = self.resolver.resolveComponentFactory(PassKeyRenameComponent);
        self.passKeyRenameComponentRef = self.viewContainerRef.createComponent(factory);
        self.passKeyRenameComponentRef.instance.onPasskeyRenameSubmit = self.onSubmitPasskyeNewUsername.bind(self);
        self.passKeyRenameComponentRef.instance.onPasskeyRenameCancelSubmit = self.onCancelSubmitForm.bind(self);

        console.log('rename passkeyFormTs constructor payload:', this.payload);

        const journeyPayload = this.payload as JourneyPayload;
        console.log('rename passkeyFormTs payload actions using interface', journeyPayload.actions);

        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('rename passkeyFormTs createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('rename passkeyFormTs createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('rename passkeyFormTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('rename passkeyFormTs onError for ' + this.formId + ' payload:', payload);
      }

      private onSubmitPasskyeNewUsername(payload: object) {
        const data = payload;
        this.submitBlock(data);
      }

    onChangeUsernameSkipSubmit = (code: string) => {
      }

    onCancelSubmitForm = (flow: object) => {
        this.submitBlock(flow);
    }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default RenamePasskeyFormSession;
